<div class="sh-notification--warning" *ngIf="showNotification$ | async">
    <div class="sh-notification__content">
        <p class="sh-notification__msg" *ngIf="notificationMsgKey$ | async as msgKey">
            <sh-html-parser [message]="msgKey | translate"></sh-html-parser>
        </p>
    </div>
    <button type="button" class="sh-pure-icon-button sh-notification__close-button" aria-label="close" (click)="onClose()">
        <svg sh-icon class="sh-icon-button__icon" [name]="'close'"></svg>
    </button>
</div>
